import { GET_SMS_LOGS } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getSmsLogs = (payload) => {
  return apiInstance.post(GET_SMS_LOGS, payload);
};
